/**
 * The signed-in identity as plain getters, kept free of the session store and
 * its API clients so shared code (storageUtils, RUM) can read it without
 * pulling recruiter session code into the candidate apps.
 *
 * The session store registers its reader when it is created. Until then, and
 * in a build that leaves the store out (the interview app), the identity is
 * empty, which is also what the store reports before a session is verified.
 */
export interface SessionIdentity {
  orgId: string | null;
  userId: string | null;
  email: string | null;
  orgName: string | null;
  isReady: boolean;
}

export const EMPTY_SESSION_IDENTITY: SessionIdentity = {
  orgId: null,
  userId: null,
  email: null,
  orgName: null,
  isReady: false,
};

let readSessionIdentity = (): SessionIdentity => EMPTY_SESSION_IDENTITY;

/** Called once by the session store with a non-subscribing read of its state. */
export const registerSessionIdentityReader = (
  reader: () => SessionIdentity
): void => {
  readSessionIdentity = reader;
};

// Reads the identity without subscribing, for callers outside React.
export const getSessionIdentity = (): SessionIdentity => readSessionIdentity();
